import { combineReducers } from 'redux'
import interestTag from './interest-tag'

export default combineReducers({
  interest_tag: interestTag
})
